/* eslint-disable */
import '../scss/style.scss';

import $ from 'jquery';
import './lib/splide';
import './lib/spNav';
import './lib/click-shop';
import './lib/gokain-area-list';
import './lib/thumbnails';
// import './lib/top-accdion';
import './lib/shoplist-detail';
import './lib/params';
import './lib/index';
import './lib/detail-boxs';
import './lib/top-more-btn';
import './lib/column';
import './lib/accordion';
// import './lib/generate';

$(function() {
});

window.onload = function () {
};
